import { useCartStore } from "@/stores/cart";
import { useCheckoutStore } from "@/stores/checkout";
import { useEventsStore } from "@/stores/events";
import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/:company?/cancelamentos",
    name: "CancelationPolicy",
    component: () => import("@/views/whitelabel-page.vue"),
    props: { page: "cancelationPolicy" },
  },
  {
    path: "/:company?/faq",
    name: "DuvidasFrequentes",
    component: () => import("@/views/whitelabel-page.vue"),
    props: { page: "faq" },
  },
  {
    path: "/:company?/meia-entrada",
    name: "MeiaEntrada",
    component: () => import("@/views/whitelabel-page.vue"),
    props: { page: "halfPricePolicy" },
  },
  {
    path: "/:company?/privacidade",
    name: "PrivacyPolicy",
    component: () => import("@/views/whitelabel-page.vue"),
    props: { page: "privacyPolicy" },
  },
  {
    path: "/:company?/sobre",
    name: "AboutUs",
    component: () => import("@/views/whitelabel-page.vue"),
    props: { page: "aboutUs" },
  },
  {
    path: "/:company?/suporte",
    name: "SuppportPage",
    component: () => import("@/views/support-page.vue"),
  },
  {
    path: "/:company?/termos",
    name: "TermsOfService",
    component: () => import("@/views/whitelabel-page.vue"),
    props: { page: "termsOfService" },
  },
  {
    path: "/:company?/",
    name: "Home",
    component: () => import("@/views/home-page.vue"),
  },
  {
    path: "/producers/:company/",
    name: "ProducerEvents",
    component: () => import("@/views/Producers/Listing/Events.vue"),
    props: true,
  },
  {
    path: "/:company?/ticket/buy/:id",
    name: "PaymentCheckout",
    component: () => import("@/views/Ticket/PaymentCheckout.vue"),
    props: true,
    beforeEnter(to, from, next) {
      to.params.id = String(to.params.id || "");

      // We only want to reset this if the user actually changed event
      // Otherwise, navigating inside the checkout should keep the cart/checkout state
      if (useEventsStore().selected?.id !== to.params.id) {
        useCartStore().reset();
        useCheckoutStore().reset();
      }

      next();
    },
  },
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/home-page.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    redirect: "/",
  },
];

export default routes;
